import React from "react";
import styled from "styled-components";
import service1 from "../assets/service1.png";
import service2 from "../assets/service2.png";
import service3 from "../assets/service3.png";
import service4 from "../assets/service4.png";

export default function Services() {
	const data = [
		{
			icon: service1,
			title: "budget camping safaris",
			subTitle:
				"Your experience of Uganda to the fullest with our budget options. Reach out to know more!",
		},
		{
			icon: service2,
			title: "Car hire",
			subTitle:
				"We have a fleet of cars including 4x4, Limousines and SUVs for your memorable trip",
		},
		{
			icon: service3,
			title: "luxurious lodge safaris",
			subTitle:
				"Be it your honeymoon or that special time of your life, we do have a wide range of options for you.",
		},
		{
			icon: service4,
			title: "Fishing Expedition",
			subTitle: "Tailored to make your fishing trip come to life",
		},
	];
	return (
		<Section id="services">
			<div className="title">
				<h2>Our Services</h2>
			</div>
			<div className="service_list">
				{data.map((service, index) => {
					return (
						<div className="service">
							<div className="icon">
								<img src={service.icon} alt="" />
							</div>
							<h3>{service.title}</h3>
							<p>{service.subTitle}</p>
						</div>
					);
				})}
			</div>
		</Section>
	);
}

const Section = styled.section`
	padding: 5rem 0;
	.title {
		text-align: center;
		padding-bottom: 1rem;
		color: #276d9b;
	}
	.service_list {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 1rem;
		.service {
			display: flex;
			flex-direction: column;
			gap: 1rem;
			padding: 2rem;
			background-color: #d1e7f6;
			box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
			transition: 0.3s ease-in-out;
			text-transform: capitalize;
			border-radius: 0.5rem;
			&:hover {
				transform: translateX(0.4rem) translateY(-1rem);
				box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
			}
			.icon {
				img {
					height: 2.4rem;
				}
			}
		}
		@media screen and (min-width: 280px) and (max-width: 720px) {
			grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
		}
		@media screen and (min-width: 720px) and (max-width: 1080px) {
			grid-template-columns: repeat(2, 1fr);
		}
	}
`;
